import * as _ from 'lodash'
import { Schema } from 'js-data'
import * as PASchema from './PAdbSchema'
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default
} from './PAdbSchema'

export const WB_DataMart = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMarts', // optional
    description: 'Schema for WB_DataMart records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMART_ID: {
            type: 'number',
            id: true,
            required: true
        },
        DM_ID: {
            type: 'string',
            length: 50
        },
        DM_NAME: {
            type: 'string',
            length: 256
        },
        DM_TYPE: {
            type: 'string',
            length: 50
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: 'number'
        },
        WB_ENTITY_ID_PRODUCT: {
            type: 'number'
        },
        WB_ENTITY_ID_PERIOD: {
            type: 'number'
        },
        UPDATE_POLICY: {
            type: 'string',
            length: 50
        },
        PLAN_SCOPE_MANUAL_IND: {
            type: 'string',
            length: 1
        },
        WB_PERIOD_ID_START: {
            type: 'number'
        },
        WB_PERIOD_ID_END: {
            type: 'number'
        },
        MARGINAL_CNS_DRIVEN_POLICY: {
            type: 'string',
            length: 50
        },
        MARGINAL_EXCESS_SHP_POLICY: {
            type: 'string',
            length: 50
        },
        MARGINAL_OVERAGE_POLICY: {
            type: 'string',
            length: 50
        },
        INCLUDE_REF_DATA_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DATASET_ID_CSV: { type: 'string', length: 500 }
    }
})

export const WB_DataMart_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_DataMart_Plan_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartPlnRs'
        },
        [PASchema.esWB_DataMart_Scope_Customer_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartCHRs'
        },
        [PASchema.esWB_DataMart_Scope_Product_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartPHRs'
        },
        [PASchema.esWB_DataMart_Aggregation_Customer_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartCARs'
        },
        [PASchema.esWB_DataMart_Restatement_Customer_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartCRRs'
        },
        [PASchema.esWB_DataMart_Aggregation_Product_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartPARs'
        },
        [PASchema.esWB_DataMart_Restatement_Product_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartPRRs'
        }
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: 'WB_MDSET_ID', foreignKeyImmutable: true, localField: 'MDSet' },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerEntity' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductEntity' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodEntity' }
        ],
        [PASchema.esWB_Period]: [
            { foreignKey: 'WB_PERIOD_ID_START', foreignKeyImmutable: true, localField: 'PeriodStart' },
            { foreignKey: 'WB_PERIOD_ID_END', foreignKeyImmutable: true, localField: 'PeriodEnd' }
        ]
    }
}

export const WB_DataMart_Plan_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartPlnRs', // optional
    description: 'Schema for WB_DataMartPlnR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTPLNR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_DATAMART_ID: {
            type: 'number'
        },
        WB_PLAN_ID: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})

export const WB_DataMart_Plan_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' },
        [PASchema.esWB_Plan]: { foreignKey: 'WB_PLAN_ID', foreignKeyImmutable: true, localField: 'Plan' }
    }
}

export const WB_DataMart_Scope_Customer_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartCHRs', // optional
    description: 'Schema for WB_DataMartCHR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTCHR_ID: { type: 'number', id: true, required: true },
        WB_SALESAREA_ID: { type: 'number' },
        WB_HIERARCHYMPR_ID: { type: 'number' },
        WB_ENTITY_ID: { type: 'number' },
        WB_DATAMART_ID: { type: 'number' },
        WB_CUSTH_ID: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CRITERIA_ID: { type: 'string', length: 50 },
        CREATED_DTTS: { type: 'number' }
    }
})

export const WB_DataMart_Scope_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' },
        [PASchema.esWB_Hierarchy]: {
            foreignKey: 'WB_CUSTH_ID',
            foreignKeyImmutable: true,
            localField: 'CustomerHierarchy'
        }
    }
}

export const WB_DataMart_Scope_Customer_Relationship_Filter = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartCHNRs', // optional
    description: 'Schema for WB_ataMartCHNR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTCHNR_ID: { type: 'number', id: true, required: true },
        WB_DATAMARTCHR_ID: { type: 'number' },
        WB_CUST_ID: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CREATED_DTTS: { type: 'number' }
    }
})

export const WB_DataMart_Scope_Customer_Relationship_Filter_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart_Scope_Customer_Relationship]: {
            foreignKey: 'WB_DATAMARTCHR_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartCHR'
        }
    }
}

export const WB_DataMart_Scope_Product_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartPHRs', // optional
    description: 'Schema for WB_DataMartPHR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTPHR_ID: { type: 'number', id: true, required: true },
        WB_SALESAREA_ID: { type: 'number' },
        WB_PRDH_ID: { type: 'number' },
        WB_HIERARCHYMPR_ID: { type: 'number' },
        WB_ENTITY_ID: { type: 'number' },
        WB_DATAMART_ID: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CRITERIA_ID: { type: 'string', length: 50 },
        CREATED_DTTS: { type: 'number' }
    }
})

export const WB_DataMart_Scope_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' }
    }
}

export const WB_DataMart_Scope_Product_Relationship_Filter = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartPHNRs', // optional
    description: 'Schema for WB_DataMartPHNR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTPHNR_ID: { type: 'number', id: true, required: true },
        WB_PRDGRP_ID: { type: 'number' },
        WB_DATAMARTPHR_ID: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CREATED_DTTS: { type: 'number' }
    }
})

export const WB_DataMart_Scope_Product_Relationship_Filter_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart_Scope_Product_Relationship]: {
            foreignKey: 'WB_DATAMARTPHR_ID',
            foreignKeyImmutable: true,
            localField: 'DataMart'
        }
    }
}

export const WB_DataMart_Aggregation_Customer_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartCARs', // optional
    description: 'Schema for WB_DataMartCAR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTCAR_ID: { type: 'number', id: true, required: true },
        WB_HIERARCHYMPR_ID: { type: 'number' },
        WB_ENTITY_ID_SRC: { type: 'number' },
        WB_DATAMART_ID: { type: 'number' },
        WB_CUSTH_ID: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CREATED_DTTS: { type: 'number' },
        ALLOC_METRIC_ID: { type: 'string', length: 50 }
    }
})

export const WB_DataMart_Aggregation_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' }
    }
}

export const WB_DataMart_Restatement_Customer_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DWB_DataMartCRRs', // optional
    description: 'Schema for WB_WB_DataMartCRR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTCRR_ID: { type: 'number', id: true, required: true },
        WB_HIERARCHYMPR_ID_TGT: { type: 'number' },
        WB_HIERARCHYMPR_ID_SRC: { type: 'number' },
        WB_DATAMART_ID: { type: 'number' },
        WB_CUST_ID_TGT: { type: 'number' },
        WB_CUST_ID_SRC: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CREATED_DTTS: { type: 'number' },
        ALLOCATION_PCNT: { type: 'number' }
    }
})

export const WB_DataMart_Restatement_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' }
    }
}

export const WB_DataMart_Aggregation_Product_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartPARs', // optional
    description: 'Schema for WB_DataMartPAR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTPAR_ID: { type: 'number', id: true, required: true },
        WB_PRDH_ID: { type: 'number' },
        WB_HIERARCHYMPR_ID: { type: 'number' },
        WB_ENTITY_ID_SRC: { type: 'number' },
        WB_DATAMART_ID: { type: 'number' },
        MODIFIED_DTTS: { type: 'number' },
        DELETED_IND: { type: 'string', length: 1 },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        CREATED_DTTS: { type: 'number' },
        ALLOC_METRIC_ID: { type: 'string', length: 50 }
    }
})

export const WB_DataMart_Aggregation_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' }
    }
}

export const WB_DataMart_Restatement_Product_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartPRRs', // optional
    description: 'Schema for WB_DataMartPRR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_DATAMARTPRR_ID: { type: 'number', id: true, required: true },
        WB_DATAMART_ID: { type: 'number' },
        ALLOCATION_PCNT: { type: 'number' },
        CREATED_DTTS: { type: 'number' },
        DELETED_DT: { type: 'string', length: 8, default: '18000101' },
        DELETED_IND: { type: 'string', length: 1 },
        MODIFIED_DTTS: { type: 'number' },
        WB_HIERARCHYMPR_ID_SRC: { type: 'number' },
        WB_HIERARCHYMPR_ID_TGT: { type: 'number' },
        WB_PROD_ID_SRC: { type: 'number' },
        WB_PROD_ID_TGT: { type: 'number' }
    }
})

export const WB_DataMart_Restatement_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart' }
    }
}

// Dictionaries
//-- Schemas
_.defaults(dctSchemaByEntitySet, {
    [PASchema.esWB_DataMart]: WB_DataMart,
    [PASchema.esWB_DataMart_Plan_Relationship]: WB_DataMart_Plan_Relationship,
    [PASchema.esWB_DataMart_Scope_Customer_Relationship]: WB_DataMart_Scope_Customer_Relationship,
    [PASchema.esWB_DataMart_Scope_Customer_Relationship_Filter]: WB_DataMart_Scope_Customer_Relationship_Filter,
    [PASchema.esWB_DataMart_Scope_Product_Relationship]: WB_DataMart_Scope_Product_Relationship,
    [PASchema.esWB_DataMart_Scope_Product_Relationship_Filter]: WB_DataMart_Scope_Product_Relationship_Filter,
    [PASchema.esWB_DataMart_Aggregation_Customer_Relationship]: WB_DataMart_Aggregation_Customer_Relationship,
    [PASchema.esWB_DataMart_Restatement_Customer_Relationship]: WB_DataMart_Restatement_Customer_Relationship,
    [PASchema.esWB_DataMart_Aggregation_Product_Relationship]: WB_DataMart_Aggregation_Product_Relationship,
    [PASchema.esWB_DataMart_Restatement_Product_Relationship]: WB_DataMart_Restatement_Product_Relationship
})

//-- Table Names
_.defaults(dctTableNameByEntitySet, {
    [PASchema.esWB_DataMart]: '/AZR/WB_DATAMART',
    [PASchema.esWB_DataMart_Plan_Relationship]: '/AZR/WB_DATAMARTPLNR',
    [PASchema.esWB_DataMart_Scope_Customer_Relationship]: '/AZR/WB_DATAMARTCHR',
    [PASchema.esWB_DataMart_Scope_Customer_Relationship_Filter]: '/AZR/WB_DATAMARTCHNR',
    [PASchema.esWB_DataMart_Scope_Product_Relationship]: '/AZR/WB_DATAMARTPHR',
    [PASchema.esWB_DataMart_Scope_Product_Relationship_Filter]: '/AZR/WB_DATAMARTPHNR',
    [PASchema.esWB_DataMart_Aggregation_Customer_Relationship]: '/AZR/WB_DATAMARTCAR',
    [PASchema.esWB_DataMart_Restatement_Customer_Relationship]: '/AZR/WB_DATAMARTCRR',
    [PASchema.esWB_DataMart_Aggregation_Product_Relationship]: '/AZR/WB_DATAMARTPAR',
    [PASchema.esWB_DataMart_Restatement_Product_Relationship]: '/AZR/WB_DATAMARTPRR'
})

//-- Logical Key
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_DataMart]: [],
    [PASchema.esWB_DataMart_Plan_Relationship]: [],
    [PASchema.esWB_DataMart_Scope_Customer_Relationship]: [],
    [PASchema.esWB_DataMart_Scope_Customer_Relationship_Filter]: [],
    [PASchema.esWB_DataMart_Scope_Product_Relationship]: [],
    [PASchema.esWB_DataMart_Scope_Product_Relationship_Filter]: [],
    [PASchema.esWB_DataMart_Aggregation_Customer_Relationship]: [],
    [PASchema.esWB_DataMart_Restatement_Customer_Relationship]: [],
    [PASchema.esWB_DataMart_Aggregation_Product_Relationship]: [],
    [PASchema.esWB_DataMart_Restatement_Product_Relationship]: []
})

//-- Other Foreign Keys without jsData  Relationship
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_DataMart]: {},
    [PASchema.esWB_DataMart_Plan_Relationship]: {},
    [PASchema.esWB_DataMart_Scope_Customer_Relationship]: {},
    [PASchema.esWB_DataMart_Scope_Customer_Relationship_Filter]: {},
    [PASchema.esWB_DataMart_Scope_Product_Relationship]: {},
    [PASchema.esWB_DataMart_Scope_Product_Relationship_Filter]: {},
    [PASchema.esWB_DataMart_Aggregation_Customer_Relationship]: {},
    [PASchema.esWB_DataMart_Restatement_Customer_Relationship]: {},
    [PASchema.esWB_DataMart_Aggregation_Product_Relationship]: {},
    [PASchema.esWB_DataMart_Restatement_Product_Relationship]: {}
})

//-- Key Pools
_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_DataMart]: { sequence_name: '/AZR/WB_DATAMART_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_DataMart_Plan_Relationship]: { sequence_name: '/AZR/WB_DATAMARTPLNR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_DataMart_Scope_Customer_Relationship]: {
        sequence_name: '/AZR/WB_DATAMARTCHR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Scope_Customer_Relationship_Filter]: {
        sequence_name: '/AZR/WB_DATAMARTCHNR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Scope_Product_Relationship]: {
        sequence_name: '/AZR/WB_DATAMARTPHR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Scope_Product_Relationship_Filter]: {
        sequence_name: '/AZR/WB_DATAMARTPHNR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Aggregation_Customer_Relationship]: {
        sequence_name: '/AZR/WB_DATAMARTCAR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Restatement_Customer_Relationship]: {
        sequence_name: '/AZR/WB_DATAMARTCRR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Aggregation_Product_Relationship]: {
        sequence_name: '/AZR/WB_DATAMARTPAR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_DataMart_Restatement_Product_Relationship]: {
        sequence_name: '/AZR/WB_DATAMARTPRR_SEQ',
        ...KeyGenSpecs_default
    }
})
